export default {
	headers: [],
	nbRowText: '0 indu | 1 indu | {count} indus',
	fieldRequired: '* Champs obligatoires',
	selectPaymentRecipientProject: '1. Sélectionner le destinataire de versement',
	selectPaymentRecipientAm: '2. Sélection de l\'acteur',
	selectProject: '1. Sélection du projet',
	selectDataLineConcerned: '2. Sélectionner les lignes de soins concernées',
	undueDeclerationSection: '3. Déclaration de l\'indu',
	select: 'Sélectionner',
	search: 'Rechercher',
	actorNumber: 'Numéro d\'acteur *',
	projectNameOrCode: 'Nom ou Code du projet *',
	btnExport: 'Exporter',
	motives: [
		{
			value: 'balance',
			text: 'Balance'
		},
		{
			value: 'technical_error',
			text: 'Erreur technique'
		},
		{
			value: 'control',
			text: 'Contrôle'
		},
		{
			value: 'undue',
			text: 'Indu'
		}
	],
	actor: 'Acteur',
	address: 'Adresse',
	dialingCode: 'Indicatif',
	phone: 'Numéro de téléphone',
	name: 'Nom',
	coordinate: 'Coordonnées',
	form: {
		address: {
			label: 'Numéro et libellé de voie *',
			rules: [
				{
					name: 'requiredFn'
				}
			]
		},
		city: {
			label: 'Ville *',
			rules: [
				{
					name: 'requiredFn'
				}
			]
		},
		zipcode: {
			label: 'Code postal *',
			rules: [
				{
					name: 'requiredFn'
				}
			]
		},
		mail: {
			label: 'Adresse email',
			rules: [
				{
					name: 'emailFn'
				}
			]
		}
	},
	selected: 'Liste des indus sélectionnés',
	dataline: {
		default: 'Veuillez effectuer une recherche pour retrouver les lignes de soins concernées',
		selected: 'Ligne de soin sélectionnée | Ligne de soin sélectionnée | Lignes de soins sélectionnées',
		totalAmount: 'Montant total',
		validation: 'Pour valider votre déclaration d\'indu, sélectionnez une ou plusieurs lignes de soins.',
		message: 'Faites une recherche et ajoutez-la ou les à votre sélection.'
	},
	dataLineWithUndueDisabled: 'Cette ligne de soin n\'est pas sélectionnable car elle est déjà rattachée à un indu.',
	refundOptions: {
		title: '3. Mode de remboursement',
		question: 'Acceptez-vous que le montant de cet indu soit déduit du/des prochain(s) paiement(s) ?',
		yes: 'Oui',
		no: 'Non, je rembourserai l\'indu par un virement bancaire direct vers la CPAM 75 (CPAM de Paris)',
		info: 'Si vous cochez oui, merci de ne pas tenir compte de la notification par voie postale qui sera effectuée par la CPAM de Paris.',
		tooltip: 'Par exemple, si vous avez un indu de 400 € et que votre prochain paiement est de 1 000 €, vous recevrez uniquement 600 €. Avec ce mode de remboursement, aucune action n\'est nécessaire de votre part.'
	},
	submit: 'Valider la déclaration d\'indu',
	undueConfirm: 'Êtes-vous sûr de vouloir créer un indu d\'un montant de {amount} portant sur {count} ligne de soin ? | Êtes-vous sûr de vouloir créer un indu d\'un montant de {amount} portant sur {count} lignes de soin ?',
	phoneArea: {
		label: 'Indicatif',
		none: 'Aucun'
	},
	successCreateMessage: 'Indu créé avec succès',
	errorcreateMessage: 'Erreur lors de la création de l\'indu',
	actorErrorMessage: 'Erreur lors de la modification de l\'acteur',
	btnCancel: 'Annuler',
	btnConfirm: 'Confirmer',
	declaration: {
		amount: 'Montant de l\'indu',
		refundOptions: 'Autorisation de reprise sur flux',
		yes: 'Oui',
		no: 'Non',
		undueConfirm: 'Êtes-vous sûr de vouloir créer un indu d\'un montant de {amount} ?',
		amountInvalid: 'Le montant saisi n\'est pas valide.',
		amountRequired: 'Le champ « Montant de l\'indu » est requis.'
	},
	dialogTitle: 'Enregistrement'
};
